var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store-info-container"},[_c('AppConfigSection',{on:{"app-selected":_vm.handleAppSelected}}),_c('StoreListSection',{attrs:{"selected-app-id":_vm.selectedAppId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }